import {Injectable} from '@angular/core';
import {CoreService} from '../../../core/service';
import {Firestore} from '@angular/fire/firestore';

/**
 * ### UserAccessService
 * Provides Firestore access methods related to user permissions and access control.
 *
 * @class UserAccessService
 * @extends CoreService
 * @description This service inherits from `CoreService` and leverages shared Firestore utilities.
 *              It is intended for managing user access configurations, roles, and permissions
 *              across different features and modules within the application.
 *
 * @providedIn root — This service is available application-wide as a singleton.
 */
@Injectable({
  providedIn: 'root',
})
export class UserAccessService extends CoreService {

  /**
   * Constructs the `UserAccessService` and injects Firestore for use in inherited utility methods.
   *
   * @param {Firestore} firestore - Firebase Firestore instance used for database operations.
   */
  constructor(firestore: Firestore) {
    super(firestore);
  }

}
